import { render, staticRenderFns } from "./ModificarMixer.vue?vue&type=template&id=4b0ab5c5&scoped=true&"
import script from "./ModificarMixer.vue?vue&type=script&lang=js&"
export * from "./ModificarMixer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ab5c5",
  null
  
)

export default component.exports